var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGripSolid1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 512,
    viewBox: "0 0 448 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 136C128 113.9 110.1 96 88 96H40C17.9 96 0 113.9 0 136V184C0 206.1 17.9 224 40 224H88C110.1 224 128 206.1 128 184V136ZM128 328C128 305.9 110.1 288 88 288H40C17.9 288 0 305.9 0 328V376C0 398.1 17.9 416 40 416H88C110.1 416 128 398.1 128 376V328ZM160 136V184C160 206.1 177.9 224 200 224H248C270.1 224 288 206.1 288 184V136C288 113.9 270.1 96 248 96H200C177.9 96 160 113.9 160 136ZM288 328C288 305.9 270.1 288 248 288H200C177.9 288 160 305.9 160 328V376C160 398.1 177.9 416 200 416H248C270.1 416 288 398.1 288 376V328ZM320 136V184C320 206.1 337.9 224 360 224H408C430.1 224 448 206.1 448 184V136C448 113.9 430.1 96 408 96H360C337.9 96 320 113.9 320 136ZM448 328C448 305.9 430.1 288 408 288H360C337.9 288 320 305.9 320 328V376C320 398.1 337.9 416 360 416H408C430.1 416 448 398.1 448 376V328Z",
    fill: "#747680"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripSolid1);
export default __webpack_public_path__ + "static/media/grip-solid 1.b458873bd33b6c7077d374d5a78ca253.svg";
export { ForwardRef as ReactComponent };